import baseInitState from 'src/helpers/redux/baseInitState'
import baseReducer from 'src/helpers/redux/baseReducer'

import { actionType } from './umroh.action'

const initState = {
  ...baseInitState,
  isLoadingExport: false,
  isLoadingPromo: false,
}

export default function reducer(state = initState, action) {
  switch (action.type) {
    case actionType('exportFile').request:
      return {
        ...state,
        isLoadingExport: true,
      }
    case actionType('exportFile').success:
      return {
        ...state,
        isLoadingExport: false,
      }
    case actionType('exportFile').error:
      return {
        ...state,
        isLoadingExport: false,
      }
    case actionType('promoUmroh').request:
      return {
        ...state,
        isLoadingPromo: true,
      }
    case actionType('promoUmroh').success:
    case actionType('promoUmroh').error:
      return {
        ...state,
        isLoadingPromo: false,
      }
    default:
      return baseReducer(state, action, actionType)
  }
}
